"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MarkerLayer_1 = require("./MarkerLayer");
var Marker = function (props) {
    var renderCard = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var card = new window.SMap.Card();
        var cardWidth = (_b = (_a = props.card) === null || _a === void 0 ? void 0 : _a.options) === null || _b === void 0 ? void 0 : _b.width;
        var cardHeight = (_d = (_c = props.card) === null || _c === void 0 ? void 0 : _c.options) === null || _d === void 0 ? void 0 : _d.height;
        if (cardWidth && cardHeight) {
            card.setSize(cardWidth, cardHeight);
        }
        card.getHeader().innerHTML = (_e = props.card) === null || _e === void 0 ? void 0 : _e.header;
        card.getBody().innerHTML = (_f = props.card) === null || _f === void 0 ? void 0 : _f.body;
        card.getFooter().innerHTML = (_g = props.card) === null || _g === void 0 ? void 0 : _g.footer;
        sMarker.decorate(window.SMap.Marker.Feature.Card, card);
    };
    var markerLayer = (0, react_1.useContext)(MarkerLayer_1.MarkerLayerContext);
    var _a = props.coords, lng = _a.lng, lat = _a.lat;
    var coords = window.SMap.Coords.fromWGS84(lng, lat);
    var sMarker = new window.SMap.Marker(coords, false);
    markerLayer === null || markerLayer === void 0 ? void 0 : markerLayer.addMarker(sMarker);
    if (props.card) {
        renderCard();
    }
    (0, react_1.useEffect)(function () {
        return function () {
            markerLayer.removeMarker(sMarker, true);
        };
    });
    return null;
};
exports.default = Marker;
//# sourceMappingURL=Marker.js.map